"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
var messages_es_1 = require("./messages_es");
var messages_cat_1 = require("./messages_cat");
window.adperfTracker = window.adperfTracker || {};
exports.config = {
    apiKey: APIKEY,
    publicApiHost: PUBLICAPIHOST,
    context: {
        defaultCountryCode: "ES",
        channelCode: "WEB_PÚBLICO",
        templateCode: "ESTIMATED_SAVINGS_SIIE",
        wizardCode: "NOU6TEMA_SITES",
        urlOk: "https://www.nou6tema.com/",
        domainId: DOMAINID,
        solutionCode: "VENTAS_FV",
        moduleRef: "CS3W-450MS",
        flatStructureRef: "ESTRUCTURA_INCLINADA_COPLANAR",
        inclinationStructureRef: "ESTRUCTURA_COPLANAR_COPLANAR",
        defaultVoltage: "3X400",
        defaultPhases: "3",
        defaultProfileRef: "ESTIMATE00INDUSTRIA",
        defaultAnnualPowerPriceIncrease: 0.2,
        defaultAnnualPerformanceLoss: 0.4,
        defaultAnnualPowerConsumptionIncrease: 0,
        financingType: "none",
        defaultTariff: "2.0TD",
        individualTariff: "2.0TD",
        organizationTariff: "3.0TD",
        defaultContractedPower: 4.7,
        individualContractedPower: 4.7,
        organizationContractedPower: 30,
        individualMaxConsume: 400,
        organizationMaxConsume: 5000,
        individualDefaultConsume: 75,
        organizationDefaultConsume: 800,
        defaultModulesTilt: 20,
        defaultModulesAzimuth: 0,
        regionAutocomplete: "es",
    },
    formMessages: {
        es: messages_es_1.messages_es,
        cat: messages_cat_1.messages_cat,
    },
    provinces: [
        "Araba/Álava",
        "Albacete",
        "Alicante/Alacant",
        "Almería",
        "Ávila",
        "Badajoz",
        "Balears, Illes",
        "Barcelona",
        "Burgos",
        "Cáceres",
        "Cádiz",
        "Castellón/Castelló",
        "Ciudad Real",
        "Córdoba",
        "Coruña, La",
        "Cuenca",
        "Girona",
        "Granada",
        "Guadalajara",
        "Gipuzkoa",
        "Huelva",
        "Huesca",
        "Jaén",
        "León",
        "Lleida",
        "Rioja, La",
        "Lugo",
        "Madrid",
        "Málaga",
        "Murcia",
        "Navarra",
        "Ourense",
        "Asturias",
        "Palencia",
        "Palmas, Las",
        "Pontevedra",
        "Salamanca",
        "Santa Cruz de Tenerife",
        "Cantabria",
        "Segovia",
        "Sevilla",
        "Soria",
        "Tarragona",
        "Teruel",
        "Toledo",
        "Valencia/València",
        "Valladolid",
        "Bizkaia",
        "Zamora",
        "Zaragoza",
        "Ceuta",
        "Melilla",
    ],
    redirect: true,
    showCalculations: false,
    showInclination: false,
    showLanguageSelector: true,
    showOrientation: false,
    showRecommender: false,
    showModules: false,
};
